import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { axiosInt } from '../../../utils';

export const FETCH_LOADABLE_DATA_KEY = 'fetchLoadableData';
export const fetchLodableDataApi = async (url: string): Promise<any> => {
  const response = await axiosInt.get(url);
  return response.data;
};

export const useFetchLoadableData = (
  url: string,
  options?: Partial<UseQueryOptions<any, Error, any, readonly unknown[]>>
) => {
  const {
    data: loadableData,
    isLoading: isLoadingLoadableData,
    error: errorFetchingLoadableData,
  } = useQuery<any>({
    queryKey: [FETCH_LOADABLE_DATA_KEY, url],
    queryFn: () => fetchLodableDataApi(url),
    ...options,
  });

  return { loadableData, isLoadingLoadableData, errorFetchingLoadableData };
};
